import { ToggleButtonGroup, ToggleButton, ToggleButtonGroupProps } from 'react-bootstrap';

import './AwayterToggleButtons.scss';

type Option = {
    id: string | number;
    label: string;
};

type AwayterToggleButtonsProps = {
    dark?: boolean;
    name?: string;
    value?: any;
    options?: Option[];
    onChange?: (value: any, event: any) => void;
    size?: 'sm' | 'lg';
    vertical?: boolean;
    defaultValue?: string | number;
};

const AwayterToggleButtons = ({
    dark = false,
    name = 'awayter-toggle-button-group',
    value,
    onChange,
    size,
    vertical,
    options = [
        { id: 1, label: 'cosa1' },
        { id: 2, label: 'cosa2' },
    ],
}: AwayterToggleButtonsProps) => {
    return (
        <div className={`awayter-toggle-buttons ${dark ? 'dark-mode' : ''}`}>
            <ToggleButtonGroup
                type="radio"
                name={name}
                value={value}
                defaultValue={options[0].id}
                size={size}
                vertical={vertical}
                onChange={onChange}
            >
                {options.map(({ id, label }) => (
                    <ToggleButton key={id} type="radio" id={String(id)} value={id}>
                        {label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </div>
    );
};

export default AwayterToggleButtons;
